import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"
import { compose, withProps, branch, renderNothing } from "recompose"
import isBoolean from "lodash/isBoolean"
import { Flex } from "@infotech/uikit-grid"
import { OkIcon, CloseIcon } from "@infotech/uikit-icons"
import styles from "./styles.css"

const SUCCESS_COLOR = `#18981d`
const FAILURE_ICON = `#cf1124`

const StatusIcon = ({ succeedStatus }) => (
  <div
    className={cn(styles[`status-icon`], {
      [styles[`status-icon--succeed`]]: succeedStatus,
      [styles[`status-icon--failed`]]: !succeedStatus,
    })}
  >
    {succeedStatus ? (
      <OkIcon style={{ fill: SUCCESS_COLOR }} />
    ) : (
      <CloseIcon style={{ fill: FAILURE_ICON }} />
    )}
  </div>
)

const UnitFormatter = ({ unit }) => (unit ? ` (${unit})` : ``)

const Row = ({
  name,
  plannedValue,
  actualValue,
  unit,
  withStatus,
  succeedStatus,
  customStatus,
}) => (
  <Flex className={styles[`inner-accorderon-row`]}>
    <div className={cn([styles[`name-column`], styles[`name-font`]])}>
      {name}
    </div>
    <div className={styles[`plan-fact-column`]}>
      {plannedValue}
      <UnitFormatter unit={unit} />
    </div>
    <div className={styles[`plan-fact-column`]}>
      {actualValue}
      <UnitFormatter unit={unit} />
    </div>
    <div className={styles[`status-column`]}>
      {withStatus && (
        <StatusIcon
          succeedStatus={isBoolean(customStatus) ? customStatus : succeedStatus}
        />
      )}
    </div>
  </Flex>
)

const enhance = compose(
  branch(({ name }) => !name, renderNothing),
  withProps(({ plannedValue, actualValue, unit }) => ({
    succeedStatus: unit
      ? plannedValue >= actualValue
      : plannedValue === actualValue,
  })),
)

Row.propTypes = {
  name: PropTypes.string,
  plannedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actualValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string,
  withStatus: PropTypes.bool,
  customStatus: PropTypes.bool,
}

Row.defaultProps = {
  name: ``,
  plannedValue: ``,
  actualValue: ``,
  unit: ``,
  withStatus: false,
  customStatus: undefined,
}

export default enhance(Row)
